import { QRCode } from '@/features/misc/QRCode';
import { QueryStringRouteManage } from '@/features/misc/QueryStringRouteManager';
import { NotFound } from '@/components/Pages/Errors/NotFound';
import { LoginPage } from '@/features/login/routes';
import { AuthPage } from '@/features/auth/routes';
import { RecommendedBrowserPage } from '@/features/auth/components/index';
import { TransferSignUpPage } from '@/features/auth/components/registration/transferIndex';
import { Navigate } from 'react-router-dom';
import { ReservationForm } from '@/features/reservation';

function SwitchPage() {
  const currentQueryParams = window.location.search;
  const urlParams = new URLSearchParams(currentQueryParams);
  if (urlParams.get('source') === 'line') {
    window.fromLine = true;
    const currentPath = window.location.pathname;
    const redirectUrl = encodeURIComponent(currentPath + currentQueryParams);
    // LIFFのエンドポイントURLが複数設定できないため、１箇所にリダイレクトさせている
    return <Navigate to={`/transferSignUp?redirectUrl=${redirectUrl}`} />; // LINEユーザー
  }
  return <AuthPage />; // 通常ユーザー
}

export const publicRoutes = [
  { path: '/', element: <AuthPage /> },
  { path: '/auth/redirect', element: <QueryStringRouteManage /> },
  { path: '/qrcode', element: <QRCode /> },
  { path: '/auth/login', element: <LoginPage /> }, // LINEログアウトできるように一時的に残している
  { path: '/patient/reservation', element: <ReservationForm isLogin={false} /> },
  { path: '/*', element: <NotFound /> },
  { path: '/recommended-browser', element: <RecommendedBrowserPage /> },

  // LINEから認証なしで遷移した時用。画面から遷移させる動線はない。
  { path: '/transferSignUp', element: <TransferSignUpPage /> },
  // ↓ クエリパラメータにsource=lineがあればLINEページに遷移。なければ通常のログインページに遷移する
  { path: '/patient/facilities', element: <SwitchPage /> },
  { path: '/patient/reservation', element: <SwitchPage /> },
  { path: '/patient/top/qrcode', element: <SwitchPage /> },
  { path: '/patient/mypage', element: <SwitchPage /> }
];

export default publicRoutes;
